import React from "react";

const TabNavigation = ({ 
  tabs, 
  activeTab, 
  onTabChange 
}) => {
  return (
    <div className="flex gap-3 sm:gap-4 mt-6 overflow-x-auto no-scrollbar">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onTabChange(tab.key)}
          className={`px-5 py-1.5 rounded-2xl whitespace-nowrap transition-all duration-200 flex items-center gap-2 text-sm font-semibold border ${
            activeTab === tab.key
              ? "bg-indigo-500 text-white border-indigo-500 shadow-sm"
              : "bg-white text-slate-900 border-slate-200 hover:border-slate-300"
          }`}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
